import { Toast } from "vant";
import interfaces from "@/interfaces/index";
export default {
  // 将时间戳转字符串日期格式
  timeStampInit(time, str) {
    if (!time) {
      return;
    }
    let date = "";
    let Y = new Date(time).getFullYear();
    let M =
      new Date(time).getMonth() + 1 >= 10
        ? new Date(time).getMonth() + 1
        : "0" + (new Date(time).getMonth() + 1);
    let D =
      new Date(time).getDate() >= 10
        ? new Date(time).getDate()
        : "0" + new Date(time).getDate();
    if (str) {
      date = Y + str + M + str + D + "T" + "00:00:00";
    } else {
      date = Y + "-" + M + "-" + D + "T" + "00:00:00";
    }
    return date;
  },
  // 将日期转时间戳
  unTimeStampInit(day) {
    if (!day) {
      return;
    }
    let Y = new Date(day).getFullYear();
    let M =
      new Date(day).getMonth() + 1 >= 10
        ? new Date(day).getMonth() + 1
        : "0" + (new Date(day).getMonth() + 1);
    let D =
      new Date(day).getDate() >= 10
        ? new Date(day).getDate()
        : "0" + new Date(day).getDate();
    let time = new Date(Y + "/" + M + "/" + D + " " + "00:00:00").getTime();
    return time;
  },
  // 去掉T
  removeT(str) {
    if (str) {
      str = str.replace("T", " ");
      return str;
    } else {
      return "";
    }
  },
  timeYYYYMMDD(time, str) {
    if (!time) {
      return;
    }
    let date = "";
    let Y = new Date(time).getFullYear();
    let M =
      new Date(time).getMonth() + 1 >= 10
        ? new Date(time).getMonth() + 1
        : "0" + (new Date(time).getMonth() + 1);
    let D =
      new Date(time).getDate() >= 10
        ? new Date(time).getDate()
        : "0" + new Date(time).getDate();
    if (str) {
      date = Y + str + M + str + D;
    } else {
      date = Y + "-" + M + "-" + D;
    }
    return date;
  },
  getDiscount(num) {
    var str = num.toString().split(".");
    if (str.length == 2) {
      var length = str[1].length;
      return Math.round(num * Math.pow(10, length)) / Math.pow(10, length - 1);
    } else if (str.length == 1) {
      return str * 10;
    } else {
      return false;
    }
  },
  // 有T去掉T没有T不去后面都设置00:00:00
  removeTAdd00(str) {
    if (str) {
      if (str.indexOf("T") != -1) {
        str = str.split("T")[0] + " " + "00:00:00";
      } else {
        str = str.split(" ")[0] + " " + "00:00:00";
      }
    }
    return str;
  },
  // 去重 对于数组
  removeRepeat(arr) {
    if (arr) {
      let s = new Set(arr);
      arr = [...s];
      return arr;
    }
  },
  // 判断一个字符串出现最多的
  findMostTerm(str) {
    if (str) {
      if (str.length === 1) {
        return str;
      } else {
        let charObj = {};
        for (let i = 0; i < str.length; i++) {
          if (!charObj[str.charAt(i)]) {
            charObj[str.charAt(i)] = 1;
          } else {
            charObj[str.charAt(i)] += 1;
          }
        }
        let maxVal = 1;
        let maxChar = "";
        for (let key in charObj) {
          if (charObj[key] >= maxVal) {
            maxVal = charObj[key];
            maxChar = key;
          }
        }
        return maxChar;
      }
    }
  },
  // 计算时间差
  timeDif(start, end) {
    if (start && end) {
      start = new Date(start).getTime();
      end = new Date(end).getTime();
      let time = end - start;
      let h = parseInt(time / 3600000);
      let m = parseInt((time - h * 3600000) / 60000);
      return h + "时" + m + "分";
    }
  },
  // 判断是不是再微信里面
  isWechat() {
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    var isT = false;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      isT = true;
    }
    return isT;
  },
  // 判断是不是再外部浏览器里面
  isOuterBrowser() {
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    var isT = true;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      isT = false;
    }
    if (ua.match(/AlipayClient/i) == "alipayclient") {
      isT = false;
    }
    return isT;
  },
  // 是否是正式环境
  isEnvProd() {
    let href = window.location.href;
    let flag = false;
    if (href.indexOf("https://weixin.loongair.cn") > -1) {
      flag = true;
    }
    return flag;
  },
  // 判断是微信还是支付宝
  curPayEnv() {
    let payId = "WeiXinMP";
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      payId = "WeiXinMP";
    }
    if (ua.match(/AlipayClient/i) == "alipayclient") {
      payId = "AliPayUnifyWap";
    }
    return payId;
  },
  // 判断是微信还是支付宝
  curPayEnv2() {
    let payId = "WeiXinMP";
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      payId = "WeiXinMP";
    } else {
      payId = "AliPayUnifyWap";
    }
    return payId;
  },
  // 云商城判断是微信还是支付宝
  curPayEnvMall() {
    let payId = "WechatMPMall";
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      payId = "WechatMPMall";
    } else {
      payId = "AlipayWapMall";
    }
    return payId;
  },
  // 判断机型
  phoneType() {
    var n = navigator.userAgent;
    if (n.indexOf("Android") > -1 || n.indexOf("Linux") > -1) {
      return "Android";
    } else if (n.indexOf("iPhone") > -1) {
      return "Ios";
    } else if (n.indexOf("Windows Phone") > -1) {
      return "Window";
    } else if (n.indexOf("Google Phone") > -1) {
      return "Google";
    }
  },
  // 判断航空公司
  getComType(str) {
    let a = "";
    if (str.indexOf("G5") != -1) {
      a = "华夏航空";
    }
    if (str.indexOf("TV") != -1) {
      a = "西藏航空";
    }
    return a;
  },
  // 计算时间差
  timeDif(start, end) {
    if (start && end) {
      start = new Date(start).getTime();
      end = new Date(end).getTime();
      let time = end - start;
      let h = parseInt(time / 3600000);
      let m = parseInt((time - h * 3600000) / 60000);
      return h + "时" + m + "分";
    }
  },
  // 判断是不是再微信里面
  isWechat() {
    var ua = navigator.userAgent.toLowerCase(); //获取判断用的对象
    var isT = false;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      isT = true;
    }
    return isT;
  },
  // 判断机型
  phoneType() {
    var n = navigator.userAgent;
    if (n.indexOf("Android") > -1 || n.indexOf("Linux") > -1) {
      return "Android";
    } else if (n.indexOf("iPhone") > -1) {
      return "Ios";
    } else if (n.indexOf("Windows Phone") > -1) {
      return "Window";
    } else if (n.indexOf("Google Phone") > -1) {
      return "Google";
    }
  },
  // 校验身份证
  checkIdCard(card) {
    let checkFlg = false;
    let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (reg.test(card)) {
      checkFlg = true;
    }
    return checkFlg;
  },
  // 校验手机号  /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/
  checkPhone(phone) {
    let checkPhone = false;
    let regPhone = /^1[3-9]{1}\d{9}$/;
    if (regPhone.test(phone)) {
      checkPhone = true;
    }
    return checkPhone;
  },
  checkEmail(email) {
    let check = false;
    let regEmail = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
    if (regEmail.test(email)) {
      check = true;
    }
    return check;
  },
  checkEmail2(email) {
    let check = false;
    let regEmail = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    if (regEmail.test(email)) {
      check = true;
    }
    return check;
  },
  // 校验4位数字
  checkFlightNo(val) {
    let check = false;
    let reg = /^\d{4}$/;
    if (reg.test(val)) {
      check = true;
    }
    return check;
  },
  getYMDArr(val) {
    let arr = [];
    if (val) {
      var date = new Date(val);
      let Y = date.getFullYear();
      let M = date.getMonth();
      let D = date.getDate();
      arr = [Y, M, D];
    }
    return arr;
  },
  replaceT(val) {
    if (val) {
      val = val.replace("T", " ");
      val = val.split(" ")[0];
    }
    return val;
  },
  // 获取id
  getFoidId(val) {
    switch (val) {
      case '身份证':
        return 1;
      case "护照":
        return 2;
      case "台胞证":
        return 3;
      case "港澳通行证":
        return 4;
      case "外国人永久居留身份证":
        return 6;
      case "港澳台居民居住证":
        return 11;
      case "户口簿":
        return 21;
      case "回乡证":
        return 22;
      case "海员证":
        return 25;
      case "外国人出入境证":
        return 32;
      case "其他":
        return 100;
    }
  },
  foidNameList: ['身份证', '护照', '台胞证', '港澳通行证', '外国人永久居留身份证', '港澳台居民居住证', '户口簿', '回乡证', '海员证', '外国人出入境证', '其他'],
  // 获取证件可输入长度
  getFoidInfo(val) {
    switch (+val) {
        case 1:
          return {name: "身份证"};
        case 2: 
          return {name: "护照", singlemaxlen: 11};
        case 3:
          return {name: "台胞证", singlemaxlen: 11};
        case 4:
          return {name: "港澳通行证", singlemaxlen: 11};
        case 6:
          return {name: "外国人永久居留身份证", len: 15};
        case 11:
          return {name: "港澳台居民居住证", len: 18};
        case 21:
          return {name: "户口簿", minlen: 9, maxlen: 15};
        case 22:
          return {name: "回乡证", singlemaxlen: 11};
        case 25:
          return {name: "海员证", len: 9};
        case 32:
          return {name: "外国人出入境证", len: 9};
        case 100:
          return {name: "其他证件", minlen: 9, maxlen: 15};
    }
  },
  checkNeedTips(val, foid) {
     let foidInfo = this.getFoidInfo(val);
     let needTips = '';
     if (foidInfo.len && foidInfo.len != foid.length) {
        needTips = `${foidInfo.name}的长度有误，应为${foidInfo.len}位`;
     } else if (foidInfo.minlen && foidInfo.maxlen) {
        if (foid.length < foidInfo.minlen || foid.length > foidInfo.maxlen) {
            needTips = `${foidInfo.name}的长度有误，应为${foidInfo.minlen}~${foidInfo.maxlen}位`;
        }
     } else if (foidInfo.singlemaxlen && foidInfo.singlemaxlen < foid.length) {
        needTips = `${foidInfo.name}的长度有误，应为小于等于${foidInfo.singlemaxlen}位`;
     }
     return needTips;
  },
  // 分割数字4位一个空格
  divisionStr(val) {
    val = val.replace(/(.{4})/g, "$1 ");
    return val;
  },
  initTtime(val) {
    if (val) {
      if (val.toString().indexOf("T") > -1) {
        val = val
          .toString()
          .replace("T", " ")
          .replace(/-/g, "/");
      }
      val = new Date(val).getTime();
    }
    return val;
  },
  initTtime2(val) {
    if (val) {
      if (val.toString().indexOf("T") > -1) {
        val = val
          .toString()
          .replace("T", " ")
          .replace(/-/g, "/");
      }
    }
    return val;
  },
  // 计算时间差2
  timeDif2(start, end) {
    if (start && end) {
      start = this.initTtime2(start);
      end = this.initTtime2(end);
      start = new Date(start).getTime();
      end = new Date(end).getTime();
      let time = end - start;
      let h = parseInt(time / 3600000);
      let m = parseInt((time - h * 3600000) / 60000);
      return h + "时" + m + "分";
    }
  },
  switchSex(val) {
    switch (val) {
      case "男":
        return 1;
      case "女":
        return 2;
    }
  },
  // 反过来
  unSwitchSex(val) {
    switch (+val) {
      case 1:
        return "男";
      case 2:
        return "女";
    }
  },
  // 亚运宝贝报名组别
  switchGrounp(val) {
    switch (val) {
      case "亚运语言保障组":
        return 1;
      case "艺体特长组":
        return 2;
      case "礼宾组":
        return 3;
      case "常规组":
        return 5;
    }
  },
  // 组别反过来
  unSwitchGrounp(val) {
    switch (+val) {
      case 1:
        return "亚运语言保障组";
      case 2:
        return "艺体特长组";
      case 3:
        return "礼宾组";
      case 5:
        return "常规组";
    }
  },
  // 政治面貌
  switchPolitic(val) {
    switch (val) {
      case "共青团员":
        return 1;
      case "中共党员":
        return 2;
      case "群众":
        return 3;
      case "其他":
        return 5;
    }
  },
  // 政治面貌反过来
  unSwitchPolitic(val) {
    switch (+val) {
      case 1:
        return "共青团员";
      case 2:
        return "中共党员";
      case 3:
        return "群众";
      case 5:
        return "其他";
    }
  },
  // 最高学历
  switchEducate(val) {
    switch (val) {
      case "博士研究生":
        return 1;
      case "硕士研究生":
        return 2;
      case "大学本科":
        return 3;
      case "大学专科":
        return 5;
    }
  },
  // 最高学历 反向
  unSwitchEducate(val) {
    switch (+val) {
      case 1:
        return "博士研究生";
      case 2:
        return "硕士研究生";
      case 3:
        return "大学本科";
      case 5:
        return "大学专科";
    }
  },
  // 最高学历性质
  switchNatureE(val) {
    switch (val) {
      case "全日制":
        return 1;
      case "非全日制":
        return 2;
    }
  },
  // 最高学历性质 反向
  unSwitchNatureE(val) {
    switch (+val) {
      case 1:
        return "全日制";
      case 2:
        return "非全日制";
    }
  },
  // 是否有工作经历
  switchWorkFlg(val) {
    switch (val) {
      case "是":
        return 1;
      case "否":
        return 2;
    }
  },
  // 是否有工作经历 反向
  unSwitchWorkFlg(val) {
    switch (+val) {
      case 1:
        return "是";
      case 2:
        return "否";
    }
  },
  getUrlQuery(name, Url) {
    //URL GET 获取值
    var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i"),
      url = Url || location.href;
    if (reg.test(url)) return decodeURI(RegExp.$2.replace(/\+/g, " "));
    return "";
  },
  // 倒序排序对象
  sortObj(obj) {
    var arr = [];
    for (var i in obj) {
      arr.push([obj[i], i]);
    }
    arr.reverse();
    var len = arr.length;
    var obj = {};
    for (var i = 0; i < len; i++) {
      obj[arr[i][1]] = arr[i][0];
    }
    return obj;
  },
  // 亚运宝贝字段对应汉字
  switchSubmitYaYun(val) {
    switch (val) {
      case "group":
        return "报名组别";
      case "name":
        return "姓名";
      case "sexType":
        return "性别";
      case "birthday":
        return "生日";
      case "age":
        return "年龄";
      case "height":
        return "身高";
      case "weight":
        return "体重";
      case "foidNo":
        return "证件号";
      case "nativePlace":
        return "籍贯";
      case "nationality":
        return "国籍";
      case "reconcily":
        return "民族";
      case "politicCountenance":
        return "政治面貌";
      case "addressDetail":
        return "现住地址";
      case "mail":
        return "电子邮箱";
      case "educationLevel":
        return "最高学历";
      case "natureEducation":
        return "最高学历性质";
      case "graduateSchool":
        return "最高学历毕业院校";
      case "speciality":
        return "所学专业";
      case "graduateTime":
        return "毕业时间";
      case "specLevel":
        return "专业特长";
      case "specLevelCerts":
        return "专业特长证书";
      case "languageLevel":
        return "外语语种";
      case "languageLevelCerts":
        return "外语语种证书";
      case "graduateCerts":
        return "毕业证及学位证";
      case "workFlg":
        return "是否有工作经历";
      case "workStartTime":
        return "参加工作时间";
      case "workExperience":
        return "工作经历";
      case "imageUrl":
        return "个人照片";
      case "others":
        return "其他";
      case "mobile":
        return "手机号码";
    }
  },
  // 轮椅类型
  wheeChairType: [
    {
      name: "地面轮椅服务",
      code: "WCHR"
    },
    {
      name: "上下客梯轮椅服务",
      code: "WCHS"
    },
    {
      name: "客舱轮椅（无自理能力）服务",
      code: "WCHC"
    }
  ],
  // 孕妇周期
  pregnantWeek: [
    {
      name: "怀孕32周以内的健康孕妇",
      code: "1"
    },
    {
      name: "怀孕超过32周（含）但不足36周的健康孕妇",
      code: "2"
    },
    {
      name:
        "长龙航空有权拒绝承运怀孕36周（含）以上者、预产期临近但无法准确确定日期、顺产不足7天、难产以及早产经医生诊断不宜乘机者",
      code: "3"
    }
  ],
  // 视听障碍患者
  impairArr: [
    {
      name:
        "有成人陪伴的盲人（含严重视力障碍）旅客/聋哑旅客/听觉障碍旅客乘机，按一般旅客接受运输",
      code: "1"
    },
    {
      name:
        "上下机地点有人照料迎送的盲人（含严重视力障碍）旅客/聋哑旅客/听觉障碍旅客单独旅行",
      code: "2"
    },
    {
      name:
        "无成人陪伴和接送的盲人（含严重视力障碍）旅客/聋哑旅客/听觉障碍旅客",
      code: "3"
    }
  ],
  // 轮椅服务原因
  wheeChairReason: ["手术", "身体缺陷", "年龄过大", "其他（备注原因）"],
  // 自理能力
  wcrSelfHelp: [
    "完全不能行走",
    "协助下可行走小段距离",
    "可独自行走小段距离",
    "其他（备注原因）"
  ],
  // 判断乘机人类型
  getPsgType(val) {
    if (val) {
      switch (+val) {
        case 1:
          return "成人";
        case 2:
          return "儿童";
        case 3:
          return "婴儿";
      }
    } else {
      return "";
    }
  },
  addGolbalUserInfo(userInfo) {
    let obj = {
      Name: userInfo.Name,
      Mobile: userInfo.Mobile
    };
    localStorage.setItem("golbalUserInfo", JSON.stringify(obj));
  },
  // 获取时间段
  getDateDuan(start, end) {
    var date = "";
    var startTime = "";
    var endTime = "";
    if (start) {
      date = new Date(start.replace("T", " ").replace(/-/g, "/"));
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let D = date.getDate();
      let h = date.getHours();
      let m =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      date = M + "月" + D + "日";
      startTime = h + ":" + m;
    }
    if (end) {
      var ends = new Date(end.replace("T", " ").replace(/-/g, "/"));
      let h = ends.getHours();
      let m =
        ends.getMinutes() < 10 ? "0" + ends.getMinutes() : ends.getMinutes();
      endTime = h + ":" + m;
    }
    return date + " " + startTime + " - " + endTime;
  },
  // 校验是不是活动时间段
  checkActivityTime(current, start, end) {
    if (start) {
      start = new Date(start.replace("T", " ").replace(/-/g, "/"));
      start = new Date(start).getTime();
    }
    if (end) {
      end = new Date(end.replace("T", " ").replace(/-/g, "/"));
      end = new Date(end).getTime();
    }
    if (current < start) {
      return 1; // 活动前
    }
    if (current >= start && current <= end) {
      return 2; // 活动中
    }
    if (current > end) {
      return 3; // 活动后
    }
  },
  // 判断距离活动是不是大于24个小时
  // 校验是不是活动时间段
  check24Hour(current, start) {
    if (start) {
      start = new Date(start.replace("T", " ").replace(/-/g, "/"));
      start = new Date(start).getTime();
    }
    let timeDiff = start - current;
    if (timeDiff / (24 * 3600 * 1000) >= 1) {
      return parseInt(timeDiff / (24 * 3600 * 1000));
    } else {
      return timeDiff / (24 * 3600 * 1000);
    }
  },
  // 返回时间位数
  returnDigit(val, type) {
    if (val && val < 10) {
      if (type == 1) {
        val = "0";
      }
    }
    if (val && val >= 10) {
      if (type == 1) {
        val = val.toString().split("")[0];
      } else {
        val = val.toString().split("")[1];
      }
    }
    return val;
  },
  // 校验乘客类型
  checkPsgType(Brithday, departureTime) {
    let fullYear = 0;
    let time = this.initTtime(departureTime);
    fullYear = (time - new Date(Brithday).getTime()) / 31536000000;
    if (fullYear > 0 && fullYear < 2) {
      return 3;
    }
    if (fullYear >= 2 && fullYear < 12) {
      return 2;
    }
    if (fullYear >= 12) {
      return 1;
    }
  },
  // 返回无陪儿童  5到12岁
  getChildPsg(result, departureTime) {
    let arr = [];
    let fullYear = 0;
    let time = this.initTtime(departureTime);
    result.map((ele, index) => {
      fullYear = (time - new Date(ele.Brithday).getTime()) / 31536000000;
      if (fullYear >= 5 && fullYear < 12) {
        let type = this.checkPsgType(ele.Brithday, departureTime);
        ele.TravellerTypeCH = this.getPsgType(type);
        ele.TravellerType = type;
        arr.push(ele);
      }
    });
    return arr;
  },
  // 返回非婴儿乘客
  getNormalPsg(result, departureTime) {
    let arr = [];
    let fullYear = 0;
    let time = this.initTtime(departureTime);
    result.map((ele, index) => {
      fullYear = (time - new Date(ele.Brithday).getTime()) / 31536000000;
      if (fullYear >= 2) {
        let type = this.checkPsgType(ele.Brithday, departureTime);
        ele.TravellerTypeCH = this.getPsgType(type);
        ele.TravellerType = type;
        arr.push(ele);
      }
    });
    return arr;
  },
  // 乘客列表只要成人
  getAdultPsg(result, departureTime) {
    let arr = [];
    let fullYear = 0;
    let time = this.initTtime(departureTime);
    result.map((ele, index) => {
      fullYear = (time - new Date(ele.Brithday).getTime()) / 31536000000;
      if (fullYear >= 12) {
        let type = this.checkPsgType(ele.Brithday, departureTime);
        ele.TravellerTypeCH = this.getPsgType(type);
        ele.TravellerType = type;
        arr.push(ele);
      }
    });
    return arr;
  },
  // 如果是婴儿票的可用乘机人
  getInfantPsg(result, departureTime) {
    let arr = [];
    let fullYear = 0;
    let time = this.initTtime(departureTime);
    result.map((ele, index) => {
      fullYear = (time - new Date(ele.Brithday).getTime()) / 31536000000;
      if (fullYear < 12) {
        let type = this.checkPsgType(ele.Brithday, departureTime);
        ele.TravellerTypeCH = this.getPsgType(type);
        ele.TravellerType = type;
        arr.push(ele);
      }
    });
    return arr;
  },
  // 获取已选的儿童数量
  getChildrenCount(result, departureTime) {
    let fullYear = 0;
    let childrenCount = 0;
    let time = this.initTtime(departureTime);
    result.map((ele, index) => {
      if (ele.selected) {
        fullYear = (time - new Date(ele.Brithday).getTime()) / 31536000000;
        if (fullYear < 12 && fullYear >= 2) {
          childrenCount += 1;
        }
      }
    });
    return childrenCount;
  },
  getInfantCount(result, departureTime) {
    let fullYear = 0;
    let infantCount = 0;
    let time = this.initTtime(departureTime);
    result.map((ele, index) => {
      if (ele.selected) {
        fullYear = (time - new Date(ele.Brithday).getTime()) / 31536000000;
        if (fullYear < 2 && fullYear >= 0) {
          infantCount += 1;
        }
      }
    });
    return infantCount;
  },
  //去除html标签
  deleteHtmlLabel(str) {
    let reg = /<\/?.+?\/?>/g;
    let reg2 = /&ldquo;|&rdquo;|&nbsp;/g;
    return str.replace(reg, "").replace(reg2, "");
  },
  // 手机格式判断
  phoneReg(phone) {
    let reg = /^1[3-9]{1}\d{9}$/;
    if (!reg.test(phone)) {
      return false;
    } else {
      return true;
    }
  },
  //去除两边空格
  trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  // 对象里面出去两边空格
  objTrim(obj) {
    let newObj = {};
    for (let key in obj) {
      if (typeof obj[key] === 'string') {
        newObj[key] = this.trim(obj[key]);
      } else {
        newObj[key] = obj[key];
      }
    }
    return newObj;
  },
  loadingOpen() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      message: "加载中...",
      forbidClick: true,
      loadingType: "spinner"
    });
  },
  loadingClose() {
    Toast.clear();
  },
  // js加减乘除精度损失问题
  // js加法
  add(acc, cur) {
    let accL =
      String(acc).split(".").length > 1 ? String(acc).split(".")[1].length : 0;
    let curL =
      String(cur).split(".").length > 1 ? String(cur).split(".")[1].length : 0;
    let len = Math.max(accL, curL);
    let res =
      (acc * Math.pow(10, len) + cur * Math.pow(10, len)) / Math.pow(10, len);
    return res;
  },
  // js减法
  minus(acc, cur) {
    let accL =
      String(acc).split(".").length > 1 ? String(acc).split(".")[1].length : 0;
    let curL =
      String(cur).split(".").length > 1 ? String(cur).split(".")[1].length : 0;
    let len = Math.max(accL, curL);
    let res =
      (acc * Math.pow(10, len) - cur * Math.pow(10, len)) / Math.pow(10, len);
    return res;
  },
  // js乘法
  mutiply(acc, cur) {
    let accL =
      String(acc).split(".").length > 1 ? String(acc).split(".")[1].length : 0;
    let curL =
      String(cur).split(".").length > 1 ? String(cur).split(".")[1].length : 0;
    let len = accL + curL;
    let res =
      (acc * Math.pow(10, accL) * (cur * Math.pow(10, curL))) /
      Math.pow(10, len);
    return res;
  },
  // js除法
  divide(acc, cur) {
    let accL =
      String(acc).split(".").length > 1 ? String(acc).split(".")[1].length : 0;
    let curL =
      String(cur).split(".").length > 1 ? String(cur).split(".")[1].length : 0;
    let len = accL + curL;
    let res =
      (acc * Math.pow(10, accL)) /
      (cur * Math.pow(10, curL)) /
      Math.pow(10, len);
    return res;
  },
  // 数组对象某个属性排序
  compare(property, desc) {
    return function(a, b) {
      var value1 = a[property];
      var value2 = b[property];
      if (desc == true) {
        // 升序排列
        return value1 - value2;
      } else {
        // 降序排列
        return value2 - value1;
      }
    };
  },
  // 亚运好礼提示
  getYaYun(fromCityCode) {
    let str = "";
    switch (fromCityCode) {
      case "NGB":
        str =
          "凡购买该产品的旅客均可在航班起飞当日在宁波栎社国际机场T2航站楼三楼E岛（航空售票）柜台处持本人有效证件领取迎亚运专属礼品一份（浙江长龙航空19cm飞机模型+毛绒飞机玩具+2022年杭州亚运会纪念首日封）。";
        break;
      case "WNZ":
        str =
          "凡购买该产品的旅客均可在航班起飞当日在温州龙湾国际机场T2航站楼3楼出发厅A区温州莱特航空柜台或航班起飞当日在温州市鹿城区车站大道东游大厦1103室温州易翔航空两处持本人有效证件领取迎亚运专属礼品一份（浙江长龙航空19cm飞机模型+毛绒飞机玩具+2022年杭州亚运会纪念首日封）。";
        break;
      case "XIY":
        str =
          "凡购买该产品的旅客均可在航班起飞当日在西安咸阳国际机场T2号航站楼出发厅221门进左手方舟售票柜台处（工作时间8：30～19：00）持本人有效证件领取迎亚运专属礼品一份（浙江长龙航空19cm飞机模型+毛绒飞机玩具+2022年杭州亚运会纪念首日封）。";
        break;
      case "CTU":
        str =
          "凡购买该产品的旅客均可在航班起飞当日在成都双流国际机场T2号航站楼出发厅9号门与10号门之间76号售票柜台处（工作时间05：30～22：00）持本人有效证件领取迎亚运专属礼品一份（浙江长龙航空19cm飞机模型+毛绒飞机玩具+2022年杭州亚运会纪念首日封）。";
        break;
      case "HRB":
        str =
          "凡购买该产品的旅客均可在航班起飞当日在哈尔滨太平国际机场T2号航站楼负一楼EB014室（工作时间05：30～21：30）持本人有效证件领取迎亚运专属礼品一份（浙江长龙航空19cm飞机模型+毛绒飞机玩具+2022年杭州亚运会纪念首日封）";
        break;
      case "CGQ":
        str =
          "凡购买该产品的旅客均可在航班起飞当日在长春龙嘉国际机场乘坐航班登机口（工作时间 06：50～19：05）持本人有效证件领取迎亚运专属礼品一份（浙江长龙航空19cm飞机模型+毛绒飞机玩具+2022年杭州亚运会纪念首日封）";
        break;
      default:
        str =
          "凡购买该产品的旅客均可在航班起飞当日在杭州萧山国际机场浙江长龙航空售票柜台持本人有效证件领取迎亚运专属礼品一份（浙江长龙航空19cm飞机模型+毛绒飞机玩具+2022年杭州亚运会纪念首日封）。";
    }
    return str;
  },
  /**
   * 微信登录地址拼接
   * @param url 需拼接地址
   * @param return
   */
  spliceWlogin: function(url) {
    let start =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx15dab1aedad459b0&redirect_uri=";
    let middle = window.encodeURIComponent(url);
    let end =
      "&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect";
    let result = start + middle + end;
    return result;
  },
  // 去掉T及后面的
  splitT(str) {
    if (str) {
      str = str.split("T")[0];
      return str;
    } else {
      return "";
    }
  },
  // 微信跳转报错问题，同意封装
  wxJumpPro(link) {
    sessionStorage.setItem("toH5Mall", 1);
    window.location.href = link;
  },
  // 解密
  dH(param, r) {
    if (!param) {
      return;
    }
    let stringArr = param.split("&");
    stringArr.map((item, index) => {
      stringArr[index] = (parseInt(item) - 7 - r) / (2 + index);
    });
    return String.fromCharCode.apply(this, stringArr);
  },
  // 获取随机数
  rand(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  },
  // 反转数字
  revers(r) {
    r = r
      .toString()
      .split("")
      .reverse()
      .join("");
    return +r;
  },
  // 获取最终随机数
  pM(b) {
    let r = this.rand(1000, 8000);
    let h = (r + b).toString();
    let t = new Date().getTime().toString();
    let e = (this.revers(r) * 6 + 3 + b).toString().padStart(8, "0");
    return h + t + e;
  },
  secret(param, r) {
    let str1 = this.dH(param, r);
    let res = [];
    if (str1) {
      str1.split("").map((d, i) => {
        // 数字0-9和.和字母A-Z和字母a-z
        res += "\\ue" + str1.charCodeAt(i).toString(16) + "1";
      });
      return unescape(res.replace(/\\/g, "%"));
    }
  },
  // 组合价格明细
  getPriceList(obj) {
    let list = [];
    // 机票
    list.push([]);
    if (obj.psgLen == 0) {
      list[0].push({
        typeName: "机票(成人)",
        price: obj.salePrice,
        number: 1
      });
      if (obj.tripType == 2) {
        list[0][0].typeName = "去程 机票(成人)";
        list[0].push({
          typeName: "返程 机票(成人)",
          price: obj.backSalePrice,
          number: 1
        });
      }
    } else {
      if (obj.adultCount) {
        list[0].push({
          typeName: "机票(成人)",
          price: obj.salePrice,
          number: obj.adultCount
        });
        if (obj.tripType == 2) {
          list[0][0].typeName = "去程 机票(成人)";
          list[0].push({
            typeName: "返程 机票(成人)",
            price: obj.backSalePrice,
            number: obj.adultCount
          });
        }
      }
      if (obj.childrenCount) {
        list[0].push({
          typeName: "机票(儿童)",
          price: obj.childSalePrice,
          number: obj.childrenCount
        });
        if (obj.tripType == 2) {
          let len = list[0].length - 1;
          list[0][len].typeName = "去程 机票(儿童)";
          list[0].push({
            typeName: "返程 机票(儿童)",
            price: obj.backChildSalePrice,
            number: obj.childrenCount
          });
        }
      }
      if (obj.infantCount) {
        list[0].push({
          typeName: "机票(婴儿)",
          price: obj.infantSalePrice,
          number: obj.infantCount
        });
        if (obj.tripType == 2) {
          let len = list[0].length - 1;
          list[0][len].typeName = "去程 机票(婴儿)";
          list[0].push({
            typeName: "返程 机票(婴儿)",
            price: obj.backInfantSalePrice,
            number: obj.infantCount
          });
        }
      }
    }
    // 税费
    list.push([]);
    obj.taxes.map(d => {
      if (obj.psgLen == 0 && +d.adultTax) {
        list[1].push({
          typeName: d.taxItemName + "(成人)",
          price: d.adultTax,
          number: 1
        });
        if (obj.tripType == 2 && +d.adultTax) {
          list[1][list[1].length - 1].typeName = `去程 ${d.taxItemName}(成人)`;
        }
      } else {
        if (obj.adultCount && +d.adultTax) {
          list[1].push({
            typeName: `${d.taxItemName}(成人)`,
            price: d.adultTax,
            number: obj.adultCount
          });
          if (obj.tripType == 2 && +d.adultTax) {
            list[1][list[1].length - 1].typeName = `去程 ${d.taxItemName}(成人)`;
          }
        }
        if (obj.childrenCount && +d.childrenTax) {
          list[1].push({
            typeName: `${d.taxItemName}(儿童)`,
            price: d.childrenTax,
            number: obj.childrenCount
          });
          if (obj.tripType == 2 && +d.childrenTax) {
            list[1][list[1].length - 1].typeName = `去程 ${d.taxItemName}(儿童)`;
          }
        }
        if (obj.infantCount && +d.infantTax) {
          list[1].push({
            typeName: `${d.taxItemName}(婴儿)`,
            price: d.infantTax,
            number: obj.infantCount
          });
          if (obj.tripType == 2 && +d.infantTax) {
            list[1][list[1].length - 1].typeName = `去程 ${d.taxItemName}(婴儿)`;
          }
        }
      }
    });
    if (obj.backTaxes && obj.backTaxes.length) {
      obj.backTaxes.map(d => {
        if (obj.psgLen == 0 && +d.adultTax) {
          list[1].push({
            typeName: `返程 ${d.taxItemName}(成人)`,
            price: d.adultTax,
            number: 1
          });
        } else {
          if (obj.adultCount && +d.adultTax) {
            list[1].push({
              typeName: `返程 ${d.taxItemName}(成人)`,
              price: d.adultTax,
              number: obj.adultCount
            });
          }
          if (obj.childrenCount && +d.childrenTax) {
            list[1].push({
              typeName: `返程 ${d.taxItemName}(儿童)`,
              price: d.childrenTax,
              number: obj.childrenCount
            });
          }
          if (obj.infantCount && +d.infantTax) {
            list[1].push({
              typeName: `返程 ${d.taxItemName}(婴儿)`,
              price: d.infantTax,
              number: obj.infantCount
            });
          }
        }
      });
    }
    // 邮寄
    if (obj.isSelectEMS) {
      list.push([]);
      let len = list.length - 1;
      list[len].push({
        typeName: `邮寄费`,
        price: obj.ExpressAmount,
        number: 1
      });
    }
    // 休息室
    if (obj.restNumber && obj.restPrice) {
      list.push([]);
      let len = list.length - 1;
      list[len].push({
        typeName: `休息室`,
        price: obj.restPrice,
        restNumber: obj.restNumber,
        number: 1,
        type: "rest"
      });
    }
    // 行李额
    if (obj.luggagePrice) {
      list.push([]);
      let len = list.length - 1;
      list[len].push({
        typeName: `行李额`,
        price: obj.luggagePrice,
        number: 1,
        type: "single"
      });
    }
    // 优惠券
    if (obj.actualCouponAmt) {
      list.push([]);
      let len = list.length - 1;
      list[len].push({
        typeName: `优惠券`,
        price: 0 - obj.actualCouponAmt,
        showPrice: obj.actualCouponAmt,
        number: 1,
        type: "coupon"
      });
    }
    // 积分
    if (obj.integralAmt) {
      list.push([]);
      let len = list.length - 1;
      let integralAmt = parseInt(obj.integralAmt / 100);
      list[len].push({
        typeName: `积分抵扣`,
        price: 0 - integralAmt,
        showPrice: integralAmt,
        number: 1,
        type: "integral"
      });
    }
    // 旅行卡
    if (obj.travelAmt) {
        list.push([]);
        let len = list.length - 1;
        list[len].push({
          typeName: `旅行卡`,
          price: 0 - obj.travelAmt,
          showPrice: obj.travelAmt,
          number: 1,
          type: "travelCard"
        });
    }
    return list;
  },
  // 乘机人信息创单入参
  getPsgInfo(arr, disabilityIDType, disabilityId, isInfantObj) {
    let list = [];
    arr.map(d => {
      if (d.selected) {
        let obj = {
          birthday: d.Brithday,
          passengerName: d.FlierName,
          assigneeTags: d.gralEnriched,
          foidType: d.FoidType,
          foid: d.Foid,
          mobile: d.Mobile,
          travellerType: d.TravellerType,
          fromCountryCode: d.FromCountryCode ? d.FromCountryCode : "",
          issueCountryCode: d.IssueCountryCode ? d.IssueCountryCode : "",
          expireDate: d.FoidType == 21 ? '2099-12-31' : (d.ExpireDate ? d.ExpireDate : "1900-01-01T00:00:00"),
          sexType: +d.SexType ? +d.SexType : 1,
          disabilityId: disabilityId
        };
        if (disabilityIDType != 1) {
          obj.disabilityId = disabilityId;
          obj.disabilityIDType = disabilityIDType;
        }
        // 如果是婴儿票
        if (isInfantObj.isInfant == 1) {
          obj.adultName = isInfantObj.adultName;
          obj.adultTicketNum = isInfantObj.adultTicketNum;
        }
        list.push(obj);
      }
    });
    return list;
  },
  // 获取航班信息创单入参
  getFlightInfo(arr, childrenCount) {
    let list = [];
    arr.map(d => {
      let obj = {
        departureAirport: d.departureAirportInfo.airportCode,
        arriveAirport: d.arriveAirportInfo.airportCode,
        cabinName: d.cabinName,
        childCabinName: d.childCabinName,
        departureTime: d.departureTime,
        flightNum: d.flightNum,
        priceProductFareCode: d.productFareBase ? d.productFareBase : "",
        productFareCodeChild:
          childrenCount != 0 && d.productFareBase ? d.productFareBase : ""
      };
      list.push(obj);
    });
    return list;
  },
  // 判断是不是空对象
  isEmptyObject(obj) {
    let isBool = false;
    if (obj) {
      let arr = Object.keys(obj);
      if (arr.length == 0) {
        isBool = true;
      }
    }
    return isBool;
  },
  getTimeKey(val) {
    if (val) {
      var date = new Date(val);
      let Y = date.getFullYear();
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      val = Y + "-" + M + "-" + D + "T00:00:00";
      return val;
    }
  },
  // 获取日历七天列表
  getCalener(date) {
    let dateArr = [];
    if (date) {
      date = date + " " + "00:00:00";
      date = date.replace(/-/g, "/");
      date = new Date(date).getTime();
      for (let i = -3; i < 3; i++) {
        let obj = {
          time: date + 24 * 3600 * 1000 * i,
          isSelect: i == 0 ? true : false,
          key: this.getTimeKey(date + 24 * 3600 * 1000 * i)
        };
        dateArr.push(obj);
      }
    }
    return dateArr;
  },
  dateFormatT: function(inputDate) {
    let d = "";
    if (typeof inputDate == "number") {
      d = new Date(inputDate);
    } else {
      d = new Date(inputDate.replace("T", " ").replace(/-/g, "/"));
    }
    return d;
  },
  //转化时间
  getNowFormatDate: function(date) {
    var date = date ? new Date(date) : new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  // 处理时间
  handleTime(val) {
    var date = new Date(val.replace("T", " ").replace(/-/g, "/"));
    let Y = date.getFullYear();
    let M =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1;
    let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    val = Y + "-" + M + "-" + D;
    return val;
  },
  // 深copy
  depthCopy(obj) {
    let a = JSON.stringify(obj);
    a = JSON.parse(a);
    return a;
  },
  getWeekName(inDate) {
    var week;
    if (inDate.getDay() == 0) week = "周日";
    if (inDate.getDay() == 1) week = "周一";
    if (inDate.getDay() == 2) week = "周二";
    if (inDate.getDay() == 3) week = "周三";
    if (inDate.getDay() == 4) week = "周四";
    if (inDate.getDay() == 5) week = "周五";
    if (inDate.getDay() == 6) week = "周六";
    return week;
  },
  dateFormatT(inputDate) {
    let d = "";
    if (typeof inputDate == "number") {
      d = new Date(inputDate);
    } else {
      d = new Date(inputDate.replace("T", " ").replace(/-/g, "/"));
    }
    return d;
  },
  // 判断设备
  checkOs() {
    var ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet =
        /(?:iPad|PlayBook)/.test(ua) ||
        (isAndroid && !/(?:Mobile)/.test(ua)) ||
        (isFireFox && /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    return {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
  },
  // 判断设备
  checkOsType() {
    let os = this.checkOs();
    if (os.isAndroid || os.isPhone) {
      return 1;
    } else if (os.isTablet) {
      return 2;
    } else if (os.isPc) {
      return 3;
    }
  },
  // 非托运行李
  goodTypes: [
    {
      t: "手机电脑Ipad",
      v: 1
    },
    {
      t: "现金证券类",
      v: 2
    },
    {
      t: "手表首饰皮夹",
      v: 3
    },
    {
      t: "证件类物品",
      v: 4
    },
    {
      t: "电子数码配件",
      v: 5
    },
    {
      t: "充电宝锂电池",
      v: 6
    },
    {
      t: "服饰箱包类",
      v: 7
    },
    {
      t: "普通生活物品",
      v: 8
    },
    {
      t: "鲜活易腐蚀类",
      v: 9
    },
    {
      t: "易燃有气味类",
      v: 10
    },
    {
      t: "武器类物品",
      v: 11
    },
    {
      t: "文物类物品",
      v: 12
    },
    {
      t: "照片类物品",
      v: 13
    },
    {
      t: "其他",
      v: 14
    }
  ],
  // 托运行李
  checkGoodTypes: [
    {
      t: "拉杆箱",
      v: 51
    },
    {
      t: "手推车",
      v: 52
    },
    {
      t: "纸箱",
      v: 53
    },
    {
      t: "三脚架",
      v: 54
    },
    {
      t: "手提包",
      v: 55
    },
    {
      t: "背包",
      v: 56
    },
    {
      t: "其他",
      v: 57
    }
  ],
  // 行李遗失位置
  positionTypes: [
    {
      t: "前面座椅口袋",
      v: 1
    },
    {
      t: "上方行李架",
      v: 2
    },
    {
      t: "座位上",
      v: 3
    },
    {
      t: "洗手间",
      v: 4
    },
    {
      t: "地面上",
      v: 5
    },
    {
      t: "不确定",
      v: 6
    }
  ],
  // 去掉前后空格
  removeSpace(formData) {
    for (let key in formData) {
      if (formData[key]) {
        formData[key] = formData[key].toString().trim();
      }
    }
    return formData;
  },
  // 友盟统计
  checkCzc(params) {
      if (_czc) {
        _czc.push(params);
      }
  },
  // 校验正整数
  checkNumber(num) {
    let checkNumber = false;
    let regs = /(^[1-9]\d*$)/;
    if (regs.test(num)) {
      checkNumber = true;
    }
    return checkNumber;
  },
   // 将日期转成时间戳 
   unTimeStampInitNew(day) {
        if (!day) {
        return '';
        }
        day = new Date(day.replace("T", " ").replace(/-/g, "/"));
        return day.getTime();
    },
    // 在不在这个时间区间
    isSection(time, start, end) {
        if (time === 'now') {
          time = new Date().getTime();
        } else {
          time = this.unTimeStampInitNew(time);
        }
        start = this.unTimeStampInitNew(start);
        end = this.unTimeStampInitNew(end);
        if (time > start && time < end) {
            return true;
        } else {
            return false;
        }
    },
    // 对比两个日期
    comparisonTime(start, end) {
        if (start === 'now') {
            start = new Date().getTime();
        } else {
            start = this.unTimeStampInitNew(start);
        }
        end = this.unTimeStampInitNew(end);
        if (start < end) {
            return true;
        } else {
            return false;
        }
    },
    // 微信分享
    async wxShare(obj){
        /* let str1 = "https://weixin.loongair.cn/mall/index.html#/home/index?actionType=wechatLogin";
        let str1 = "https://weixin.loongair.cn/mall/index.html?code=041pNg0w3pQHfV2J5o1w3b3h7Z2pNg0J&state=123#/home/index";
        let str1 = "https://weixin.loongair.cn/mall/index.html?code=021X7gHC0FkD0i2e7uHC0OdjHC0X7gHN&state=123#/goodDetail?goodsId=3363332313489201&goodsChannel=1";
        let before1 = str1.slice(0,str1.indexOf('?'));
        let after1 = str1.slice(str1.indexOf('#'));
        console.log(before1,after1,before1+after1); */
        /* var u = navigator.userAgent;
        if (u != undefined && u != null) {
            //是否苹果手机
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isIOS) {
            //取主url
            obj.links = obj.links.split("#")[0];
            }
        } */
        let params = {
            CallBackUrl: window.encodeURIComponent(obj.links),
        };
        let res = await interfaces.getSignature(params);
        if(res.data.ErrorCode === 0){
            let configObj = {
                appId: 'wx15dab1aedad459b0',
                timestamp: res.data.Result.timestamp,
                nonceStr: res.data.Result.noncestr,
                signature: res.data.Result.signature,
            }
            let title = obj.title?obj.title:'浙江长龙航空';
            let desc = obj.desc?obj.desc:'浙江长龙航空';
            let imgUrl = obj.imgUrl;
            let links = obj.links;
            if(obj.links.indexOf("?code=")>-1 || obj.links.indexOf("?from=singlemessage")>-1){
                let before = obj.links.slice(0,obj.links.indexOf('?'));
                let after = obj.links.slice(obj.links.indexOf('#'));
                links = before+after;
            }
            // console.log(links);
            wx.config({
                debug: false,
                appId: configObj.appId,
                timestamp: configObj.timestamp,
                nonceStr: configObj.nonceStr,
                signature: configObj.signature,
                jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData']
            });
            wx.ready(function() {
                wx.onMenuShareAppMessage({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function() {
                        // alert('分享成功')
                    },
                    cancel: function() {
                        // alert('分享失败')
                    }
                });
                //微信分享菜单测试
                wx.onMenuShareTimeline({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function() {
                        // alert('分享成功')
                    },
                    cancel: function() {
                        // alert('分享失败')
                    }
                })
                //微信分享好友测试（新）
                wx.updateAppMessageShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function() {
                        // alert('分享成功')
                    },
                    cancel: function() {
                        // alert('分享失败')
                    }
                })
                //微信分享朋友圈测试（新）
                wx.updateTimelineShareData({
                    title: title, // 分享标题
                    desc: desc, // 分享描述
                    link: links, // 分享链接
                    imgUrl: imgUrl, // 分享图标
                    success: function() {
                        // alert('分享成功')
                    },
                    cancel: function() {
                        // alert('分享失败')
                    }
                })
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/assets/common.js